import Lottie from 'lottie-react';
import styled from 'styled-components';

export const FireLottie = styled(Lottie)`
  width: 58px;
  height: 80px;
  aspect-ratio: 29/40;
`;

export const Wrapper = styled.div`
  display: flex;
  padding: 0px 24px 32px 24px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 32px;
  align-self: stretch;
`;

export const IconWrapper = styled.div`
  display: flex;
  padding: 8px 0px;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  align-self: stretch;
`;

export const TextWrapper = styled.div`
  display: flex;
  padding: 0px 40px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`;

export const StreakText = styled.span`
  align-self: stretch;
  text-align: center;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
  letter-spacing: -0.2px;
`;

export const StreakDescription = styled.span`
  align-self: stretch;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

export const DaysWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;
